/**
 * Environment configuration with typed access
 */
export const env = {
  // API Configuration
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  
  // Cognito Configuration
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  cognitoRedirectUri: import.meta.env.VITE_COGNITO_REDIRECT_URI || 'http://localhost:5173/callback',
  
  // Feature Flags
  authBypassEnabled: import.meta.env.VITE_AUTH_BYPASS_ENABLED === 'true',
  aiAssistantEnabled: import.meta.env.VITE_AI_ASSISTANT_ENABLED === 'true',
  // When VITE_ENABLE_GENERATOR=false, hide all post-generation UI and auth
  generatorEnabled: import.meta.env.VITE_ENABLE_GENERATOR !== 'false',
  // Translation review mode (side-by-side + glossary annotation)
  reviewModeEnabled: import.meta.env.VITE_ENABLE_REVIEW_MODE === 'true',
  
  // Analytics
  gaMeasurementId: import.meta.env.VITE_GA_MEASUREMENT_ID || '',

  // Development
  mockApi: import.meta.env.VITE_MOCK_API === 'true',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const

export type Env = typeof env
